import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MAIN_URL = 'https://kaspreadsheet.com';

const CTA_IMAGE =
  'https://readdy.ai/api/search-image?query=Premium%20fashion%20haul%20laid%20out%20on%20a%20luxurious%20cream%20marble%20table%20sneakers%20bags%20accessories%20and%20clothing%20neatly%20arranged%20warm%20golden%20afternoon%20light%20editorial%20product%20photography%20European%20luxury%20lifestyle%20upscale%20calm%20composition%20rich%20textures&width=1600&height=700&seq=achb-cta-v3&orientation=landscape';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src={CTA_IMAGE}
        alt="Start browsing AllChinaBuy spreadsheet collections today"
        title="AllChinaBuy Spreadsheet Collections — Browse Today"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/30 to-black/55"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          <div className="lg:max-w-xl">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-5 whitespace-pre-line">
              {t('home_cta.title')}
            </h2>
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md">
              {t('home_cta.subtitle')}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={MAIN_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('home_cta.cta1')}
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <Link
              to="/allchinabuy-spreadsheet-guide"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white font-semibold text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('home_cta.cta2')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}